<div ngbDropdown class="d-inline-block">
  <button ngbDropdownToggle translate class="btn btn-outline-primary">
    app.filter
  </button>

  <div ngbDropdownMenu>
    @for (filter of filters; track filter) {
      <button
        class="dropdown-item"
        (click)="onAddFilter(filter)"
        >
        {{ filter.label | translate }}
      </button>
    }
  </div>
</div>
